import { useCallback } from "react";
import { useSnackbarMutation } from "../../hooks";
import { ReservationFilterValue } from "../../ui/pages/reservations/reservation_filters";
import { BucketAttachment } from "../models";
import { MUTATIONS } from "../mutations";

type UseAmenities = {
  onAmenityReservationsReportCreated?: (attachment: BucketAttachment) => void;
};

export function useAmenities(opts?: UseAmenities) {
  // -- create survey apartment report
  const [
    invokeCreateAmenityReservationsReport,
    {
      loading: createAmenityReservationsReportLoading,
      error: createAmenityReservationsReportError,
    },
  ] = useSnackbarMutation(MUTATIONS.CREATE_AMENITY_RESERVATIONS_REPORT, {
    onCompleted: (data) => {
      if (opts?.onAmenityReservationsReportCreated) {
        opts.onAmenityReservationsReportCreated(
          data.createAmenityReservationsReport as BucketAttachment
        );
      }
    },
  });

  const createAmenityReservationsReport = useCallback(
    (filters: ReservationFilterValue) => {
      invokeCreateAmenityReservationsReport({
        variables: {
          ...filters,
        },
      });
    },
    [invokeCreateAmenityReservationsReport]
  );

  return {
    createAmenityReservationsReport,
    createAmenityReservationsReportLoading,
    createAmenityReservationsReportError,
  };
}
